import { render, staticRenderFns } from "./Identite.vue?vue&type=template&id=b70f8364&scoped=true&"
import script from "./Identite.vue?vue&type=script&lang=js&"
export * from "./Identite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70f8364",
  null
  
)

export default component.exports